<mat-card>
    <h4 class="headingfirst">Mange Content</h4>
    <form>
   <ng-container *ngFor="let content of manageForm">   
        <mat-card-content>
     <div class="main">       <h2>About App</h2>
     </div> 
    
    <div class="row box">
        <div class="col-md-6 col-sm-6">
            <div class="row">
                <div class="col-md-12 col-sm-12">
                <mat-form-field>
                    <mat-label>About Title</mat-label>
                    <input matInput name="about_title" [(ngModel)]="content.aboutTitle">
                </mat-form-field>
            </div>
            <div class="col-md-12 col-sm-12">
                    <mat-form-field class="example-full-width">
                        <mat-label>About Description</mat-label>
                        <textarea class="textarea" matInput  name="adoutDescription" [(ngModel)]="content.adoutDescription"></textarea>
                      </mat-form-field>
            </div>
        
        </div>
        </div>
        <div class="col-md-6 col-sm-6">
            <div class="row">
                <div class="col-md-12">
                    <ng-container *ngIf="!content.aboutImage.url;else image3">
                        <label class="custom">
                            About Image
                            <input type="file" accept="image/*" (change)="uploadSingle($event,'about')"  hidden>
                        </label></ng-container>
                        <ng-template #image3>
                            <img src="{{content.aboutImage.url}}" class="logo" >
                            
                    <a (click)="deleteAboutImage(content.aboutImage,'about')" class="deleteicon mat-raised-button">Delete</a>
                        </ng-template>
                </div>
            </div>
        </div>
    </div>
    <div class="main">
        <h2>Terms & Conditions</h2>
    
    </div>
    <div class="row box">
        <div class="col-md-6 col-sm-6">
            <div class="row">
                <div class="col-md-12 col-sm-12">
                    <mat-form-field>
                        <mat-label>Term Title</mat-label>
                        <input matInput name="term_title" [(ngModel)]="content.termsTitle">
                    </mat-form-field>
                </div>
                <div class="col-md-12 col-sm-12">
                    <mat-form-field class="example-full-width">
                        <mat-label>Terms Description</mat-label>
                        <textarea class="textarea" matInput placeholder="Ex. It makes me feel..." name="terms_description" [(ngModel)]="content.termsDescription"></textarea>
                      </mat-form-field>
                </div>
            </div>
        </div>
        <div class="col-md-6 col-sm-6">
            <div class="row">
                <div class="col-md-12 col-sm-12">
              <ng-container *ngIf="!content.termsImage.url;else image1">
                    <label class="custom">
                        Term Image
                        <input type="file" accept="image/*"  (change)="uploadSingle($event,'terms')" hidden>
                    </label></ng-container>
                    <ng-template #image1>
                        <img src="{{content.termsImage.url}}" class="logo">
                        
                <a (click)="deleteAboutImage(content.termsImage,'terms')" class="deleteicon mat-raised-button">Delete</a>
                    </ng-template>
                    </div>
                    </div></div>
    </div>
    <div class="main">
        <h2>Privacy Policy</h2>
    
    </div>
    <div class="row box">
        <div class="col-md-6 col-sm-6">
            <div class="row">
                <div class="col-md-12 col-sm-12">
                    <mat-form-field>
                        <mat-label>Privacy Title</mat-label>
                        <input matInput name="privacyTitle" [(ngModel)]="content.privacyTitle" placeholder="Privacy Title">
                    </mat-form-field>
                </div>
                <div class="col-md-12 col-sm-12">
                    <mat-form-field class="example-full-width">
                        <mat-label>Privacy Description</mat-label>
                        <textarea class="textarea" matInput placeholder="Ex. It makes me feel..." name="privacyDescription" [(ngModel)]="content.privacyDescription"></textarea>
                      </mat-form-field>
                </div>
            </div>
        </div>
        <div class="col-md-6 col-sm-6">
            <div class="row">
                <div class="col-md-12 col-sm-12">
                    <ng-container *ngIf="!content.privacyImage.url;else image2">
                        <label class="custom">
                            Privacy Image
                            <input type="file" accept="image/*"  (change)="uploadSingle($event,'privacy')" hidden>
                        </label></ng-container>
                        <ng-template #image2>
                            <img src="{{content.privacyImage.url}}" class="logo">
                            
                    <a (click)="deleteAboutImage(content.privacyImage,'privacy')" class="deleteicon mat-raised-button">Delete</a>
                        </ng-template>
                    </div>
                    </div></div>
    </div>

    </mat-card-content>
    <div class="row actions">
        <mat-card-actions class="action">
            <button (click)="back()" mat-button>Back</button>
            <button (click)="UpdateContent(content.id,content)" mat-button>Edit</button>
        </mat-card-actions>
    </div></ng-container> 
    </form>
</mat-card>